import { render, staticRenderFns } from "./events.vue?vue&type=template&id=a4d26be4&"
import script from "./events.vue?vue&type=script&lang=js&"
export * from "./events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4d26be4')) {
      api.createRecord('a4d26be4', component.options)
    } else {
      api.reload('a4d26be4', component.options)
    }
    module.hot.accept("./events.vue?vue&type=template&id=a4d26be4&", function () {
      api.rerender('a4d26be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/event-listing/events.vue"
export default component.exports